import moment from 'moment';

export const TYPED_DATE_DISPLAY_FORMAT = 'MMMM Do, YYYY';

const ACCEPTED_FORMATS = [
	TYPED_DATE_DISPLAY_FORMAT,
	'MMMM D, YYYY',
	'MMM Do, YYYY',
	'MMM D, YYYY',
	'MM/DD/YYYY',
	'M/D/YYYY',
	'MM-DD-YYYY',
	'M-D-YYYY',
	'YYYY-MM-DD',
	'YYYY/MM/DD',
	'MM/DD/YY',
	'M/D/YY',
	'MM-DD-YY',
	'M-D-YY',
];

const EARLIEST_YEAR = 1900;
const LATEST_YEAR = 2100;

export const parseTypedDate = (value: string): moment.Moment | null => {
	const trimmed = value.trim();
	if (!trimmed) {
		return null;
	}

	const parsed = moment(trimmed, ACCEPTED_FORMATS, true);
	if (!parsed.isValid()) {
		return null;
	}

	const year = parsed.year();
	if (year < EARLIEST_YEAR || year > LATEST_YEAR) {
		return null;
	}

	return parsed;
};
